
import { defineComponent, ref, computed } from "vue-demi";
import SubscriptionData from "@/modules/Pricing/Subscription/subscriptionData.json";
import subscriptionDataPrepaidSL from "@/modules/Pricing/Subscription/subscriptionDataPrepaidSL.json";
import { track } from "@amplitude/analytics-browser";
import { SMUser } from "@/store";

export default defineComponent({
  name: "Subscription",

  components: {
    TabsSlider: () => import("@/modules/Pricing/Subscription/TabsSlider.vue"),
    SubscriptionBlock: () => import("@/modules/Pricing/Subscription/SubscriptionBlock.vue"),
    SubscriptionForm: () => import("@/modules/Pricing/Subscription/SubscriptionForm.vue"),
  },

  setup() {
    const subscriptionData = SubscriptionData;

    const selectedTab = ref(0);

    const tabs = computed(() => [
      { title: "Pay yearly", subtitle: "save 20%" },
      { title: "Pay monthly" },
    ]);

    const currentStep = ref<"form" | "success">("form");

    const showModal = ref(false);

    const subscriptionPlan = ref("yearly");
    const subscriptionTier = ref("premium");

    function onSubscriptionClick({ plan, tier }: { plan: string; tier: string }) {
      currentStep.value = "form";
      showModal.value = true;
      subscriptionPlan.value = plan;
      subscriptionTier.value = tier;
    }

    function goToSuccess() {
      currentStep.value = "success";
    }

    function closeFlow() {
      if (currentStep.value === "success") {
        track("Clicked 'Submit Request'", {
          plan: subscriptionPlan.value,
          tier: subscriptionTier.value,
        });
      } else {
        track("Closed the modal", { plan: subscriptionPlan.value, tier: subscriptionTier.value });
      }

      currentStep.value = "form";
      showModal.value = false;
    }

    const subscriptionDataComputed = computed(() => {
      if (!SMUser.prepaidSL) return subscriptionData.tabs[selectedTab.value].pricingOptions;

      return subscriptionDataPrepaidSL.tabs[selectedTab.value].pricingOptions;
    });

    return {
      subscriptionData,
      subscriptionDataComputed,
      selectedTab,
      tabs,
      showModal,
      currentStep,
      goToSuccess,
      closeFlow,
      onSubscriptionClick,
      subscriptionPlan,
      subscriptionTier,
    };
  },
});
